import React from "react";
import clip from "text-clipper";
import moment from "moment-timezone";

// Components
import ContentDiv from "../../utils/ContentDiv";
import BlackLink from "../../utils/BlackLink";

// CSS
import "../../../css/news-article.css";

class NewsPreview extends React.PureComponent {
	render() {
		const { item } = this.props;

		return (
			<article className="news-article-preview">
				<div className="article-date">
					{moment
						.utc(item.date_added)
						.local()
						.format("MMM DD YYYY")}
				</div>
				<h3>{item.title}</h3>
				<ContentDiv className={"article-content"}>
					{clip(item.content, 200, { html: true })}
				</ContentDiv>
				<BlackLink href={`/news/${item.permalink}`}>View story</BlackLink>
			</article>
		);
	}
}

export default NewsPreview;



// WEBPACK FOOTER //
// ./src/components/home/news/NewsPreviewItem.js